import { cloudSyncAvailable } from "../cloud/config";
import type { CloudGateway } from "../cloud/gateway";
import {
  LocalProgressStore,
  type StorageAdapter,
} from "../progress/local-store";
import { MatchPersistenceStore } from "../progress/match-persistence";
import { ProgressSession } from "../progress/session";

export const cloudConfigured = cloudSyncAvailable(import.meta.env);

const unavailableStorage: StorageAdapter = {
  getItem: () => {
    throw new Error("browser-storage-unavailable");
  },
  setItem: () => {
    throw new Error("browser-storage-unavailable");
  },
  removeItem: () => {
    throw new Error("browser-storage-unavailable");
  },
};

const browserStorage = (): StorageAdapter => {
  try {
    return window.localStorage;
  } catch {
    return unavailableStorage;
  }
};

export const createSession = (
  cloud: CloudGateway | null = null,
): ProgressSession => {
  const storage = browserStorage();
  return new ProgressSession(
    new LocalProgressStore(storage),
    cloud,
    Date.now,
    () => navigator.onLine !== false,
    new MatchPersistenceStore(storage),
  );
};
